import { Component, OnInit } from '@angular/core';
import * as JSPDF from 'jspdf';
import { ModelService } from '../model.service';
@Component({
  selector: 'app-model-pdf',
  standalone: false,
  templateUrl: './model-pdf.component.html',
  styleUrl: './model-pdf.component.scss'
 
})
export class ModelPdfComponent implements OnInit {

  constructor(private modelservice:ModelService) {}

  ngOnInit() {
   this.modelservice.model={
    name:'test',
    frameLarg:75,
    soffitto:[
      {
        lung:3200,
        larg:1200,
        frameLarg:75,
      },
      {
        lung:3200,
        larg:1200,
        frameLarg:75,
      },
      {
        lung:3200,
        larg:800,
        frameLarg:75,
      },
    ],
   }
  }

  dopdf(){
    this.modelservice.pdf_soffitto();
    return;
    /*
   // let d_canvas:any = document.createElement('canvas');
   let  d_canvas:any = document.getElementById('cc');
    d_canvas.width=300;

    d_canvas.height=300;
    
    var context = d_canvas.getContext('2d');
    context.moveTo(20, 20);
    context.lineTo(100, 20);
    context.fillStyle = "#999";
    context.beginPath();
    context.arc(100, 100, 75, 0, 2 * Math.PI);
    context.fill();
    context.fillStyle = "orange";     
    context.fillRect(20, 20, 50, 50);
    var text = d_canvas.getContext('2d');
    text.font = "24px Helvetica";
    text.fillStyle = "#000";
    text.fillText("Canvasppppp", 50, 130); 
    text.rotate(-Math.PI / 2);
    
    var ctx = d_canvas.getContext("2d");
  
    var font, text, x, y;
    
    text = "Mississippi";
    
    //Set font size before measuring
    font = 20;
    ctx.font = font + 'px Arial, sans-serif';
    //Get width of text
    var metrics = ctx.measureText(text);
 
    //Set the drawing coordinates
    x = 120;
    y = 140;
    //Style
    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';
    ctx.textBaseline = "bottom";
    //Rotate the context and draw the text
    ctx.translate(x, y);
    ctx.rotate(-Math.PI);
    ctx.fillText(text, 0, font / 2);
   */
    
    let  d_canvas:any = document.getElementById('cc');
    
    d_canvas.width=100;
    d_canvas.height=100;

    var ctx = d_canvas.getContext("2d");
    ctx.fillStyle = "orange";
    ctx.fillRect(0, 0, 200, 200);
    ctx.beginPath();
    ctx.arc(30, 30, 30, Math.PI, 1.5 * Math.PI);
    ctx.stroke();
    
    var imgData = d_canvas.toDataURL(
      'image/png');              
    var doc = new JSPDF.jsPDF('p');
    const imgProps= doc.getImageProperties(imgData);
doc.addImage(imgData,'PNG',20,25,10,10);
doc.line(20, 25, 20, 125);
doc.text('hello world',30, 30, {
  align: 'center',
  angle: 90
});

    doc.save('sample-file.pdf');
  }  
  
}
